<template>
    <div>
        <div>
            <AdminTitleBar
                :title="loc('Stats Summary Reports')"
                v-on:actionhandler="handleAction"
            />
        </div>
        <v-row class="mt-n6">
            <v-col><h2>{{  loc(stateView) }} </h2></v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right" style="max-width: 400px;">
                <v-select :items="titleBarActions" v-model="stateView"/>
            </v-col>
        </v-row>
        <div v-if="(!statsDigest && !queryStatsDigest) || isLoading">No Data Yet</div>
        <div v-else-if="stateView === 'Counts'">
            <v-row>
                <v-col></v-col>
                <v-col cols="3" class="label">30 Days</v-col>
                <v-col cols="3" class="label">90 Days</v-col>
                <v-col cols="3" class="label">Total</v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="label">Lesson Views</v-col>
                <v-col cols="3">{{statsDigest.counts.thirty.lessons}}</v-col>
                <v-col cols="3">{{statsDigest.counts.ninety.lessons}}</v-col>
                <v-col cols="3">{{statsDigest.counts.total.lessons}}</v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="label">Page Views</v-col>
                <v-col cols="3">{{statsDigest.counts.thirty.pages}}</v-col>
                <v-col cols="3">{{statsDigest.counts.ninety.pages}}</v-col>
                <v-col cols="3">{{statsDigest.counts.total.pages}}</v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="label">Users</v-col>
                <v-col cols="3">{{statsDigest.counts.thirty.uniqueusers}}</v-col>
                <v-col cols="3">{{statsDigest.counts.ninety.uniqueusers}}</v-col>
                <v-col cols="3">{{statsDigest.counts.total.uniqueusers}}</v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="label">Sessions</v-col>
                <v-col>{{statsDigest.counts.thirty.sessions}}</v-col>
                <v-col>{{statsDigest.counts.ninety.sessions}}</v-col>
                <v-col>{{statsDigest.counts.total.sessions}}</v-col>
            </v-row>
            <v-row>
                <v-col cols="3" class="label">Static File Downloads</v-col>
                <v-col>{{statsDigest.counts.thirty.static}}</v-col>
                <v-col>{{statsDigest.counts.ninety.static}}</v-col>
                <v-col>{{statsDigest.counts.total.static}}</v-col>
            </v-row>            
        </div>
        <div v-else-if="stateView === 'RegDate'">
            <div >
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr class="text-h4">
                                <th class="text-left">{{ loc('Course') }}</th>
                                <th class="text-left">{{ loc('30 Days') }}</th>
                                <th class="text-left">{{ loc('90 Days') }}</th>
                                <th class="text-left">{{ loc('Prior Year') }}</th>
                                <th class="text-left">{{ loc('Last Year') }}</th>
                                <th class="text-left">{{ loc('This Year') }}</th>
                                <th class="text-left">{{ loc('Total') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, key) in statsQueryData" v-bind:key="key">
                                <td style="max-width: 300px; width: 300px; overflow: hidden">{{ row.coursetitle || row.course }} </td>
                                <td>{{row.within30Days}}</td>
                                <td>{{row.within90Days}}</td>
                                <td>{{row.year2YearsAgo}}</td>
                                <td>{{row.yearLast}}</td>
                                <td>{{row.yearCurrent}}</td>
                                <td>{{row.totalCount}}</td>
                            </tr>

                        </tbody>
                    </template>
                </v-simple-table>
            </div>
        </div>
        <div v-else-if="queryViewList[stateView]">
            <v-row > 
                <v-col cols="12">
                    <h3>{{ stateView }}</h3>

                    <div v-if="queryStatsDigest && Object.values(queryStatsDigest)[0]">
                        <div v-if="queryViewList[stateView].levels === 3">
                            <div v-for="(course, coursekey) in queryStatsDigest" v-bind:key="coursekey">
                                <h2 class="mt-4">{{(courses.list[coursekey] && courses.list[coursekey].reftitle) || coursekey }}</h2>
                                <div v-for="(lesson, lessonkey) in course" v-bind:key="lessonkey">
                                    <h3>{{(lessons.list[lessonkey] && lessons.list[lessonkey].title) || lessonkey}}</h3>
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="text-h4">
                                                    <th class="text-left">{{ stateView }}</th>
                                                    <th class="text-left">{{ loc('30 Days') }}</th>
                                                    <th class="text-left">{{ loc('90 Days') }}</th>
                                                    <th class="text-left">{{ loc('2023') }}</th>
                                                    <th class="text-left">{{ loc('2024') }}</th>
                                                    <th class="text-left">{{ loc('2025') }}</th>
                                                    <th class="text-left">{{ loc('Total') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, key) in lesson" v-bind:key="key">
                                                    <td style="width: 300px; overflow: hidden">{{ ( ( queryViewList[stateView].title && row[queryViewList[stateView].title]) || key) }}</td>
                                                    <td>{{row.last30}}</td>
                                                    <td>{{row.last90}}</td>
                                                    <td>{{row.year2023}}</td>
                                                    <td>{{row.year2024}}</td>
                                                    <td>{{row.year2025}}</td>
                                                    <td>{{row.total}}</td>
                                                </tr>

                                            </tbody>
                                        </template>
                                    </v-simple-table>

                                </div>
                            </div>

                        </div>

                        <div v-else-if="queryViewList[stateView].levels === 2">
                            <div v-for="(course, coursekey) in queryStatsDigest" v-bind:key="coursekey">
                                <h3 class="mt-4">{{(courses.list[coursekey] && courses.list[coursekey].reftitle) || coursekey }}</h3>
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="text-h4">
                                                    <th class="text-left">{{ stateView }}</th>
                                                    <th class="text-left">{{ loc('30 Days') }}</th>
                                                    <th class="text-left">{{ loc('90 Days') }}</th>
                                                    <th class="text-left">{{ loc('2023') }}</th>
                                                    <th class="text-left">{{ loc('2024') }}</th>
                                                    <th class="text-left">{{ loc('2025') }}</th>
                                                    <th class="text-left">{{ loc('Total') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, key) in course" v-bind:key="key">
                                                    <td style="width: 300px; overflow: hidden">{{ ( ( queryViewList[stateView].title && row[queryViewList[stateView].title]) || key) }}</td>
                                                    <td>{{row.last30}}</td>
                                                    <td>{{row.last90}}</td>
                                                    <td>{{row.year2023}}</td>
                                                    <td>{{row.year2024}}</td>
                                                    <td>{{row.year2025}}</td>
                                                    <td>{{row.total}}</td>
                                                </tr>

                                            </tbody>
                                        </template>
                                    </v-simple-table>
                            </div>                            
                        </div>
                        <div v-else>
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr class="text-h4">
                                            <th class="text-left">{{ stateView }}</th>
                                            <th class="text-left">{{ loc('30 Days') }}</th>
                                            <th class="text-left">{{ loc('90 Days') }}</th>
                                            <th class="text-left">{{ loc('2023') }}</th>
                                            <th class="text-left">{{ loc('2024') }}</th>
                                            <th class="text-left">{{ loc('2025') }}</th>
                                            <th class="text-left">{{ loc('Total') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, key) in queryStatsDigest" v-bind:key="key">
                                            <td style="max-width: 300px; width: 300px; overflow: hidden">{{ ( ( courses.list[ key] && courses.list[ key].reftitle ) || key) }} </td>
                                            <td>{{row.last30}}</td>
                                            <td>{{row.last90}}</td>
                                            <td>{{row.year2023}}</td>
                                            <td>{{row.year2024}}</td>
                                            <td>{{row.year2025}}</td>
                                            <td>{{row.total}}</td>
                                        </tr>

                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>

                    </div>

                    <div v-else>
                        Not available yet 
                    </div>
                    
                </v-col>
            </v-row>
        </div>        
        <div v-else-if="stateView === 'Referers'">
            <v-row > 
                <v-col cols="4">
                    <h3>30 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.referer.thirty" :key="'referer:' + item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>90 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.referer.ninety" :key="'referer:' + item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>Total</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.referer.total" :key="'referer:' + item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
            </v-row>
        </div>      
        <div v-else-if="stateView === 'Pages'">
            <v-row > 
                <v-col cols="4">
                    <h3>30 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.pages.thirty" :key="'pages:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>90 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.pages.ninety" :key="'pages:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>Total</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.pages.total" :key="'pages:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
            </v-row>
        </div>      
        <div v-else-if="stateView === 'Lessons'">
            <v-row > 
                <v-col cols="4">
                    <h3>30 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.lessons.thirty" :key="'lessons:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>90 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.lessons.ninety" :key="'lessons:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>Total</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.lessons.total" :key="'lessons:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
            </v-row>
        </div>      
        <div v-else-if="stateView === 'Materials'">
            <v-row>
                <v-spacer></v-spacer>
                <v-col class="text-right" style="max-width: 400px;">
                    <v-select 
                        
                        :label="loc('Filter By Course')"
                        :items="courselist"
                        v-model="coursefilter"
                    />
                </v-col>
            </v-row>
            <v-row > 
                <v-col cols="12">
                    <h3>30 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.materials.thirty" :key="'materials:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="12">
                    <h3>90 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.materials.ninety" :key="'materials:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="12">
                    <h3>Total</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.materials.total" :key="'materials:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
            </v-row>
        </div>      
        <div v-else-if="stateView === 'Static' || stateView === 'Static Files'">
            <v-row > 
                <v-col cols="4">
                    <h3>30 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.static.thirty" :key="'static:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>90 Days</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.static.ninety" :key="'static:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
                <v-col cols="4">
                    <h3>Total</h3>
                    <ul style="list-style: none; padding-left:0">
                        <li v-for="(item) in statsDigest.static.total" :key="'static:'+item.name"> {{ item.name }}: {{item.value}}</li>
                    </ul>
                </v-col>
            </v-row>
        </div>           
        <v-row v-if="debug">
            <v-col class="text-right text-caption mt-10" cols="12"><span class='mr-5'>30 Days: {{ showDates.thirty }},</span> <span class='mr-5'>90 Days: {{ showDates.ninety }},</span> <span class='mr-5'>Data begins: {{ statsDigest.firstday }}</span></v-col>
        </v-row>

        <pre v-if="!isLoading && debug">
            {{ stateView }} 
        </pre>
    </div>
</template>

<script>
import { mapState } from "vuex";
import AdminTitleBar from "./Admin_TitleBar";
import { formatDate } from "../lib/filter.js";
import _sortBy from 'lodash/sortBy';
import _orderBy from 'lodash/orderBy';
import _reverse from 'lodash/reverse';


const today = formatDate()
const thirtyDays = formatDate(Date.now() - (1000 * 60 * 60 * 24 * 30))
const ninetyDays = formatDate(Date.now() - (1000 * 60 * 60 * 24 * 90))

// const viewList = ['Courses', 'Lessons', 'Materials', 'Referers', 'Pages'];
const viewList = [];
// const queryViewList = ['Courses', 'Lessons', 'Materials', 'Referers', 'Pages'];
// const headers = [
//     text: 
// ]
const querySchema = {
    Courses: {
        levels: 1,
        title: 'coursetitle',
    },
    Pages: {
        levels: 1,
        title: 'page',
    },
    Referers: {
        levels: 1,
        title: 'referer',
    },
    Static: {
        levels: 1,
        title: 'static',
    },
    "Static Files": {
        levels: 1,
        title: 'static',
    },
    Materials: {
        levels: 3,
        title: 'mattitle',
        title2: 'lessontitle',
        title3: 'coursetitle',
    },
    Lessons: {
        levels: 2,
        title: 'lessontitle',
        title2: 'coursetitle',

    },
    RegDate: {
        levels: 1,
        title: 'coursetitle'   
    }

}

export default {
    name: "StatsReport",
    components: { AdminTitleBar },
    data() {
        return {
            // courselist: [],
            coursefilter: 'All',
            debug: false,
            statsData: false,
            statsQueryData: false,
            isLoading: true,
            query: false,
            stateView: 'Counts',
            stateScope: 'summary',
            titleBarActions: [
                { text: "Counts", key: "Counts" },
                { text: "Courses", key: "Courses" },
                { text: "Lessons", key: "Lessons" },
                { text: "Materials", key: "Materials" },
                { text: "RegDate", keys: "regdate" },
                { text: "Referers", key: "Referers" },
                { text: "Pages", key: "Pages" },
                { text: "Static Files", key: "Static" },
            ],
            queryViewList: querySchema,
            // {
            //     Courses: {
            //         levels: 1,
            //         title: 'coursetitle',
            //     },
            //     Pages: {
            //         levels: 1,
            //         title: 'page',
            //     },
            //     Referers: {
            //         levels: 1,
            //         title: 'referer',
            //     },
            //     Materials: {
            //         levels: 3,
            //         title: 'mattitle',
            //         title2: 'lessontitle',
            //         title3: 'coursetitle',
            //     },
            //     Lessons: {
            //         levels: 2,
            //         title: 'lessontitle',
            //         title2: 'coursetitle',

            //     },

            // },
        }
    },
    computed: {
        ...mapState(['siteconfig', 'users', 'courses', 'lessons', 'materials', 'content', 'reports', 'localize']),
        statsDigest: function() {
            if(this.query) return false;
            if(!this.statsData) return {};
            if(this.stateView && this.stateView !== 'Counts' ) return false;
            let coursefilter = (this.coursefilter === 'All') ? false : this.coursefilter;
            // console.log("Computing statsDigest", today, thirtyDays, ninetyDays)
            let out = {
                firstday: false,
                counts: {
                    thirty: { },
                    ninety: {},
                    total: {}
                },
                courses: {
                    thirty: {},
                    ninety: {},
                    total: {}
                },
                lessons: {
                    thirty: {},
                    ninety: {},
                    total: {}
                },
                materials: {
                    thirty: {},
                    ninety: {},
                    total: {}
                },
                referer: {
                    thirty: {},
                    ninety: {},
                    total: {}
                },
                pages: {
                    thirty: {},
                    ninety: {},
                    total: {}
                },
                static: {
                    thirty: {},
                    ninety: {},
                    total: {}
                },
            };
            for(let d in this.statsData.days){
                if(d > today) continue; // this shouldn't happen?
                if(!out.firstday || d < out.firstday) out.firstday = d;
                if(d >= thirtyDays && d <= today ){
                    out.counts.thirty.lessons = out.counts.thirty.lessons ? out.counts.thirty.lessons + this.statsData.days[d].lessons : this.statsData.days[d].lessons;
                    out.counts.thirty.pages = out.counts.thirty.pages ? out.counts.thirty.pages + this.statsData.days[d].pages : this.statsData.days[d].pages;
                    out.counts.thirty.sessions = out.counts.thirty.sessions ? out.counts.thirty.sessions + this.statsData.days[d].sessions : this.statsData.days[d].sessions;
                    out.counts.thirty.uniqueusers = out.counts.thirty.uniqueusers ? out.counts.thirty.uniqueusers + this.statsData.days[d].uniqueusers : this.statsData.days[d].uniqueusers;
                    out.counts.thirty.static = out.counts.thirty.static ? out.counts.thirty.static + this.statsData.days[d].static : this.statsData.days[d].static;
                    
                    out.counts.ninety.lessons = out.counts.ninety.lessons ? out.counts.ninety.lessons + this.statsData.days[d].lessons : this.statsData.days[d].lessons;
                    out.counts.ninety.pages = out.counts.ninety.pages ? out.counts.ninety.pages + this.statsData.days[d].pages : this.statsData.days[d].pages;
                    out.counts.ninety.sessions = out.counts.ninety.sessions ? out.counts.ninety.sessions + this.statsData.days[d].sessions : this.statsData.days[d].sessions;
                    out.counts.ninety.uniqueusers = out.counts.ninety.uniqueusers ? out.counts.ninety.uniqueusers + this.statsData.days[d].uniqueusers : this.statsData.days[d].uniqueusers;
                    out.counts.ninety.static = out.counts.ninety.static ? out.counts.ninety.static + this.statsData.days[d].static : this.statsData.days[d].static;

                    out.counts.total.lessons = out.counts.total.lessons ? out.counts.total.lessons + this.statsData.days[d].lessons : this.statsData.days[d].lessons;
                    out.counts.total.pages = out.counts.total.pages ? out.counts.total.pages + this.statsData.days[d].pages : this.statsData.days[d].pages;
                    out.counts.total.sessions = out.counts.total.sessions ? out.counts.total.sessions + this.statsData.days[d].sessions : this.statsData.days[d].sessions;
                    out.counts.total.uniqueusers = out.counts.total.uniqueusers ? out.counts.total.uniqueusers + this.statsData.days[d].uniqueusers : this.statsData.days[d].uniqueusers;
                    out.counts.total.static = out.counts.total.static ? out.counts.total.static + this.statsData.days[d].static : this.statsData.days[d].static;

                    for(let k in this.statsData.days[d].courses){
                        out.courses.thirty[k] = (out.courses.thirty[k] !== undefined) ? out.courses.thirty[k] + this.statsData.days[d].courses[k] : this.statsData.days[d].courses[k];
                        out.courses.ninety[k] = (out.courses.ninety[k] !== undefined) ? out.courses.ninety[k] + this.statsData.days[d].courses[k] : this.statsData.days[d].courses[k];
                        out.courses.total[k] = (out.courses.total[k] !== undefined) ? out.courses.total[k] + this.statsData.days[d].courses[k] : this.statsData.days[d].courses[k];
                    }
                    for(let k in this.statsData.days[d].referer){
                        out.referer.thirty[k] = (out.referer.thirty[k] !== undefined) ? out.referer.thirty[k] + this.statsData.days[d].referer[k] : this.statsData.days[d].referer[k];
                        out.referer.ninety[k] = (out.referer.ninety[k] !== undefined) ? out.referer.ninety[k] + this.statsData.days[d].referer[k] : this.statsData.days[d].referer[k];
                        out.referer.total[k] = (out.referer.total[k] !== undefined) ? out.referer.total[k] + this.statsData.days[d].referer[k] : this.statsData.days[d].referer[k];
                    }
                    for(let k in this.statsData.days[d].pagelist){
                        out.pages.thirty[k] = (out.pages.thirty[k] !== undefined) ? out.pages.thirty[k] + this.statsData.days[d].pagelist[k] : this.statsData.days[d].pagelist[k];
                        out.pages.ninety[k] = (out.pages.ninety[k] !== undefined) ? out.pages.ninety[k] + this.statsData.days[d].pagelist[k] : this.statsData.days[d].pagelist[k];
                        out.pages.total[k] = (out.pages.total[k] !== undefined) ? out.pages.total[k] + this.statsData.days[d].pagelist[k] : this.statsData.days[d].pagelist[k];
                    }       
                    for(let k in this.statsData.days[d].lessonlist){
                        out.lessons.thirty[k] = (out.lessons.thirty[k] !== undefined) ? out.lessons.thirty[k] + this.statsData.days[d].lessonlist[k] : this.statsData.days[d].lessonlist[k];
                        out.lessons.ninety[k] = (out.lessons.ninety[k] !== undefined) ? out.lessons.ninety[k] + this.statsData.days[d].lessonlist[k] : this.statsData.days[d].lessonlist[k];
                        out.lessons.total[k] = (out.lessons.total[k] !== undefined) ? out.lessons.total[k] + this.statsData.days[d].lessonlist[k] : this.statsData.days[d].lessonlist[k];
                    }     
                    for(let k in this.statsData.days[d].materials){
                        if(this.coursefilter && (this.coursefilter !== 'All' && k.indexOf(this.coursefilter) !== 0)) continue;
                        out.materials.thirty[k] = (out.materials.thirty[k] !== undefined) ? out.materials.thirty[k] + this.statsData.days[d].materials[k] : this.statsData.days[d].materials[k];
                        out.materials.ninety[k] = (out.materials.ninety[k] !== undefined) ? out.materials.ninety[k] + this.statsData.days[d].materials[k] : this.statsData.days[d].materials[k];
                        out.materials.total[k] = (out.materials.total[k] !== undefined) ? out.materials.total[k] + this.statsData.days[d].materials[k] : this.statsData.days[d].materials[k];
                    }  
                    for(let k in this.statsData.days[d].staticlist){
                        out.static.thirty[k] = (out.static.thirty[k] !== undefined) ? out.static.thirty[k] + this.statsData.days[d].staticlist[k] : this.statsData.days[d].staticlist[k];
                        out.static.ninety[k] = (out.static.ninety[k] !== undefined) ? out.static.ninety[k] + this.statsData.days[d].staticlist[k] : this.statsData.days[d].staticlist[k];
                        out.static.total[k] = (out.static.total[k] !== undefined) ? out.static.total[k] + this.statsData.days[d].staticlist[k] : this.statsData.days[d].staticlist[k];
                    }                                                      
                } else if(d >= ninetyDays ){
                    out.counts.ninety.lessons = out.counts.ninety.lessons ? out.counts.ninety.lessons + this.statsData.days[d].lessons : this.statsData.days[d].lessons;
                    out.counts.ninety.pages = out.counts.ninety.pages ? out.counts.ninety.pages + this.statsData.days[d].pages : this.statsData.days[d].pages;
                    out.counts.ninety.sessions = out.counts.ninety.sessions ? out.counts.ninety.sessions + this.statsData.days[d].sessions : this.statsData.days[d].sessions;
                    out.counts.ninety.uniqueusers = out.counts.ninety.uniqueusers ? out.counts.ninety.uniqueusers + this.statsData.days[d].uniqueusers : this.statsData.days[d].uniqueusers;
                    out.counts.ninety.static = out.counts.ninety.static ? out.counts.ninety.static + this.statsData.days[d].static : this.statsData.days[d].static;

                    out.counts.total.lessons = out.counts.total.lessons ? out.counts.total.lessons + this.statsData.days[d].lessons : this.statsData.days[d].lessons;
                    out.counts.total.pages = out.counts.total.pages ? out.counts.total.pages + this.statsData.days[d].pages : this.statsData.days[d].pages;
                    out.counts.total.sessions = out.counts.total.sessions ? out.counts.total.sessions + this.statsData.days[d].sessions : this.statsData.days[d].sessions;
                    out.counts.total.uniqueusers = out.counts.total.uniqueusers ? out.counts.total.uniqueusers + this.statsData.days[d].uniqueusers : this.statsData.days[d].uniqueusers;
                    out.counts.total.static = out.counts.total.static ? out.counts.total.static + this.statsData.days[d].static : this.statsData.days[d].static;

                    for(let k in this.statsData.days[d].courses){
                        out.courses.ninety[k] = (out.courses.ninety[k] !== undefined) ? out.courses.ninety[k] + this.statsData.days[d].courses[k] : this.statsData.days[d].courses[k];
                        out.courses.total[k] = (out.courses.total[k] !== undefined) ? out.courses.total[k] + this.statsData.days[d].courses[k] : this.statsData.days[d].courses[k];
                    }
                    for(let k in this.statsData.days[d].referer){
                        out.referer.ninety[k] = (out.referer.ninety[k] !== undefined) ? out.referer.ninety[k] + this.statsData.days[d].referer[k] : this.statsData.days[d].referer[k];
                        out.referer.total[k] = (out.referer.total[k] !== undefined) ? out.referer.total[k] + this.statsData.days[d].referer[k] : this.statsData.days[d].referer[k];
                    }
                    for(let k in this.statsData.days[d].pagelist){
                        out.pages.ninety[k] = (out.pages.ninety[k] !== undefined) ? out.pages.ninety[k] + this.statsData.days[d].pagelist[k] : this.statsData.days[d].pagelist[k];
                        out.pages.total[k] = (out.pages.total[k] !== undefined) ? out.pages.total[k] + this.statsData.days[d].pagelist[k] : this.statsData.days[d].pagelist[k];
                    }  
                    for(let k in this.statsData.days[d].lessonlist){
                        out.lessons.ninety[k] = (out.lessons.ninety[k] !== undefined) ? out.lessons.ninety[k] + this.statsData.days[d].lessonlist[k] : this.statsData.days[d].lessonlist[k];
                        out.lessons.total[k] = (out.lessons.total[k] !== undefined) ? out.lessons.total[k] + this.statsData.days[d].lessonlist[k] : this.statsData.days[d].lessonlist[k];
                    }  
                    for(let k in this.statsData.days[d].materials){
                        if(this.coursefilter && (this.coursefilter !== 'All' && k.indexOf(this.coursefilter) !== 0)) continue;
                        out.materials.ninety[k] = (out.materials.ninety[k] !== undefined) ? out.materials.ninety[k] + this.statsData.days[d].materials[k] : this.statsData.days[d].materials[k];
                        out.materials.total[k] = (out.materials.total[k] !== undefined) ? out.materials.total[k] + this.statsData.days[d].materials[k] : this.statsData.days[d].materials[k];
                    }  
                    for(let k in this.statsData.days[d].staticlist){
                        out.static.ninety[k] = (out.static.ninety[k] !== undefined) ? out.static.ninety[k] + this.statsData.days[d].staticlist[k] : this.statsData.days[d].staticlist[k];
                        out.static.total[k] = (out.static.total[k] !== undefined) ? out.static.total[k] + this.statsData.days[d].staticlist[k] : this.statsData.days[d].staticlist[k];
                    }                                                             
                } else {
                    out.counts.total.lessons = out.counts.total.lessons ? out.counts.total.lessons + this.statsData.days[d].lessons : this.statsData.days[d].lessons;
                    out.counts.total.pages = out.counts.total.pages ? out.counts.total.pages + this.statsData.days[d].pages : this.statsData.days[d].pages;
                    out.counts.total.sessions = out.counts.total.sessions ? out.counts.total.sessions + this.statsData.days[d].sessions : this.statsData.days[d].sessions;
                    out.counts.total.uniqueusers = out.counts.total.uniqueusers ? out.counts.total.uniqueusers + this.statsData.days[d].uniqueusers : this.statsData.days[d].uniqueusers;
                    out.counts.total.static = out.counts.total.static ? out.counts.total.static + this.statsData.days[d].static : this.statsData.days[d].static;

                    for(let k in this.statsData.days[d].courses){
                        out.courses.total[k] = (out.courses.total[k] !== undefined) ? out.courses.total[k] + this.statsData.days[d].courses[k] : this.statsData.days[d].courses[k];
                    }
                    for(let k in this.statsData.days[d].referer){
                        out.referer.total[k] = (out.referer.total[k] !== undefined) ? out.referer.total[k] + this.statsData.days[d].referer[k] : this.statsData.days[d].referer[k];
                    }
                    for(let k in this.statsData.days[d].pagelist){
                        out.pages.total[k] = (out.pages.total[k] !== undefined) ? out.pages.total[k] + this.statsData.days[d].pagelist[k] : this.statsData.days[d].pagelist[k];
                    }  
                    for(let k in this.statsData.days[d].lessonlist){
                        out.lessons.total[k] = (out.lessons.total[k] !== undefined) ? out.lessons.total[k] + this.statsData.days[d].lessonlist[k] : this.statsData.days[d].lessonlist[k];
                    }   
                    for(let k in this.statsData.days[d].materials){
                        if(this.coursefilter && (this.coursefilter !== 'All' && k.indexOf(this.coursefilter) !== 0)) continue;
                        out.materials.total[k] = (out.materials.total[k] !== undefined) ? out.materials.total[k] + this.statsData.days[d].materials[k] : this.statsData.days[d].materials[k];
                    }   
                    for(let k in this.statsData.days[d].staticlist){
                        out.static.total[k] = (out.static.total[k] !== undefined) ? out.static.total[k] + this.statsData.days[d].staticlist[k] : this.statsData.days[d].staticlist[k];
                    }                   
                }

            }
            let r30 = [], r90 = [], rtot = [];
            let p30 = [], p90 = [], ptot = [];
            let c30 = [], c90 = [], ctot = [];
            let l30 = [], l90 = [], ltot = [];
            let m30 = [], m90 = [], mtot = [];
            let s30 = [], s90 = [], stot = [];

            for(let k in out.courses.thirty){ c30.push({name: k, value:out.courses.thirty[k]}) }
            for(let k in out.courses.ninety){ c90.push({name: k, value:out.courses.ninety[k]}) }
            for(let k in out.courses.total){ ctot.push({name: k, value:out.courses.total[k]}) }

            for(let k in out.lessons.thirty){ l30.push({name: k, value:out.lessons.thirty[k]}) }
            for(let k in out.lessons.ninety){ l90.push({name: k, value:out.lessons.ninety[k]}) }
            for(let k in out.lessons.total){ ltot.push({name: k, value:out.lessons.total[k]}) }

            for(let k in out.pages.thirty){ p30.push({name: k, value:out.pages.thirty[k]}) }
            for(let k in out.pages.ninety){ p90.push({name: k, value:out.pages.ninety[k]}) }
            for(let k in out.pages.total){ ptot.push({name: k, value:out.pages.total[k]}) }

            for(let k in out.referer.thirty){ r30.push({name: k, value:out.referer.thirty[k]}) }
            for(let k in out.referer.ninety){ r90.push({name: k, value:out.referer.ninety[k]}) }
            for(let k in out.referer.total){ rtot.push({name: k, value:out.referer.total[k]}) }

            for(let k in out.materials.thirty){ m30.push({name: k, value:out.materials.thirty[k]}) }
            for(let k in out.materials.ninety){ m90.push({name: k, value:out.materials.ninety[k]}) }
            for(let k in out.materials.total){ mtot.push({name: k, value:out.materials.total[k]}) }

            for(let k in out.static.thirty){ s30.push({name: k, value:out.static.thirty[k]}) }
            for(let k in out.static.ninety){ s90.push({name: k, value:out.static.ninety[k]}) }
            for(let k in out.static.total){ stot.push({name: k, value:out.static.total[k]}) }

            out.courses.thirty = _reverse(_sortBy(c30, ['value']))
            out.courses.ninety = _reverse(_sortBy(c90, ['value']))
            out.courses.total =  _reverse(_sortBy(ctot, ['value']))

            out.pages.thirty = _reverse(_sortBy(p30, ['value']))
            out.pages.ninety = _reverse(_sortBy(p90, ['value']))
            out.pages.total =  _reverse(_sortBy(ptot, ['value']))

            out.lessons.thirty = _reverse(_sortBy(l30, ['value']))
            out.lessons.ninety = _reverse(_sortBy(l90, ['value']))
            out.lessons.total =  _reverse(_sortBy(ltot, ['value']))

            out.materials.thirty = _reverse(_sortBy(m30, ['value']))
            out.materials.ninety = _reverse(_sortBy(m90, ['value']))
            out.materials.total =  _reverse(_sortBy(mtot, ['value']))

            out.referer.thirty = _reverse(_sortBy(r30, ['value']))
            out.referer.ninety = _reverse(_sortBy(r90, ['value']))
            out.referer.total =  _reverse(_sortBy(rtot, ['value']))

            out.static.thirty = _reverse(_sortBy(s30, ['value']))
            out.static.ninety = _reverse(_sortBy(s90, ['value']))
            out.static.total =  _reverse(_sortBy(stot, ['value']))

            return out;
        },
        queryStatsDigest: function(){
            // console.log('queryStatsDigest', this.query, this.statsQueryData)
            if(!this.query || !this.statsQueryData){ 
                console.log('no query or statsQueryData, bailing')
                return false;
            }
            let data = {};
            let key, level;
            for(const i in this.statsQueryData){
                const keys = this.statsQueryData[i] && this.statsQueryData[i]._id;
                if(!keys) continue;

                if(keys.page){
                    data[keys.page] = this.statsQueryData[i]
                    // data[keys.page] = data[keys.page] || [];
                    // data[keys.page].push(this.statsQueryData[i]);
                    key = 'page';
                    level = 1;
                } else if(keys.referer){
                    data[keys.referer] = this.statsQueryData[i]

                    // data[keys.referer] = data[keys.referer] || [];
                    // data[keys.referer].push(this.statsQueryData[i]);
                    key = 'referer';
                    level = 1;
                } else if(keys.static){
                    data[keys.static] = this.statsQueryData[i]

                    // data[keys.referer] = data[keys.referer] || [];
                    // data[keys.referer].push(this.statsQueryData[i]);
                    key = 'static';
                    level = 1;                    
                } else {
                    if(keys.material){
                        data[keys.course] = data[keys.course] || {};
                        data[keys.course][keys.lesson] = data[keys.course][keys.lesson] || {};
                        data[keys.course][keys.lesson][keys.material] = this.statsQueryData[i]
                        // data[keys.course][keys.lesson][keys.material] = data[keys.course][keys.lesson][keys.material] || [];
                        // console.log('mat data', keys, data[keys.course][keys.lesson][keys.material])
                        // data[keys.course][keys.lesson][keys.material].push(this.statsQueryData[i])
                        key = 'material';
                        level = 3;
                    } else if(keys.lesson && keys.material !== null){
                        data[keys.course] = data[keys.course] || {};
                        data[keys.course][keys.lesson] = this.statsQueryData[i]
                        // data[keys.course][keys.lesson] = data[keys.course][keys.lesson] || [];
                        // data[keys.course][keys.lesson].push(this.statsQueryData[i]);
                        key = 'lesson';
                        level = 2;
                    } else if(keys.course && keys.lesson !== null && keys.material !== null){
                        data[keys.course] = this.statsQueryData[i]
                        key = 'course';
                        level = 1;
                    }

                }

            }

            // if(level === 3){
            //     for(const k in data){
            //         for( const k1 in data[k]){
            //             for(const k2 in data[k][k1]){
            //                 data[k][k1][k2] = _orderBy(data[k], ['last30', 'year2025', 'total'], ['desc','desc', 'desc'])
            //             }
            //         }
            //         data[k] = _orderBy(data[k], ['last30', 'year2025', 'total'], ['desc','desc', 'desc'])
            //     }
            // } else if(level === 2){
            //     for(let k in data){
            //         for( const k1 in data[k]){
            //             data[k][k1] = _orderBy(data[k][k1], ['last30', 'year2025', 'total'], ['desc','desc', 'desc'])
            //         }
            //     }
            // } else {
            //     for(let k in data){
            //         data[k] = _orderBy(data[k], ['last30', 'year2025', 'total'], ['desc','desc', 'desc'])
            //     }
            // }

            return data;
            // return {
            //     data: data,
            //     key: key
            // };
        },
        showDates: function(){
            return {thirty: thirtyDays, ninety: ninetyDays}
        },   
        courselist: function() {
            let list = [  ]
            for(let k in this.courses.list){
                list.push(this.courses.list[k].reftitle);
            }
            list.sort()
            list.unshift('All')
            return list;
        }     
    },
    methods: {
        loadStats: function(initial){
            if(this.query && !initial) return this.queryStats();
            this.isLoading = true;
            this.$store.dispatch("reports/getStats")
            .then((result) => {
                // console.log("summary loaded")
                this.statsData = result;
                this.isLoading = false;
                
            })
            .catch((e) => {
                // if(e) console.log(e);   
            })
        },

        queryStats: function(){
            this.isLoading = true;
            // console.log('queryStats', this.query)

            this.$store.dispatch("reports/getStatsQuery", {query: this.query})
            .then((result) => {
                this.statsQueryData = result;
                this.isLoading = false;
                
            })
            .catch((e) => {
                // if(e) console.log(e);   
            })
        },

        handleAction: function(action, params) {
            // console.log('handleAction')

        },
        loc: function (str) {
            return (this.localize.languages[this.users.lang] && this.localize.languages[this.users.lang][str]) || str;
        },         
    },
    mounted(){
        this.$store.dispatch("lessons/getList");
        this.loadStats(true)
    }, 
    watch: {
        stateView: function(){
            // console.log("Watch", this.stateView)
            this.query = (querySchema[this.stateView]) ? this.stateView : false;
            this.loadStats();
        }
    }
}
</script>